/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import {
	Alert,
	Breadcrumb,
	Button,
	DatePicker,
	Input,
	Loading,
	Table as TableComponent,
	TabsPanel,
	Combobox,
	SchedulerModal,
	ViewsModal,
	ConfirmationModal,
	LabelSection,
} from "../../Components";
import Actions from "../../Components/GridComponents/Actions";
import 'react-dates/initialize';
import { GLOBAL } from "../../Config/global";
import { FORM_DATA } from "../../Config/form_data";
import "font-awesome/css/font-awesome.min.css";
import { APPCONFIG } from '../../app.config';
import moment from "moment";
import { loadProducerCode } from '../../Config/producerData';
import { truncate } from '../../Shared/Utils';
import userAuth from "../../Config/userauth";
import * as QLIBS from '../../qLibsHelpers';
import { DEFAULT_HEADER } from '../../Config/userToken';
import { PolicyInfoModal } from './policyInfoModal';
import PolicyRowDetail from './partials/policyRowDetail';
import { APIS } from '../../Config/apis';
import { ErrorLevel } from '../../Components/Alert/errorLevel';
import InformationModal from '../../Components/InformationModal';

const fmtMoney = (n, currency) =>
	new Intl.NumberFormat("es-AR", {
		style: "currency",
		currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(n ?? 0);

class Cartera extends React.Component {
	constructor(props) {
		super(props);

		this.filterTabs = [
			{
				label: 'Filtro por Fecha'
			},
			{
				label: 'Filtro por Producto'
			},
			{
				label: 'Filtro por Póliza'
			}
		];
		this.state = {
			tableData: [],
			ramos: [],
			productos: [],
			name: '',
			checkedItems: [],
			productorSelected: 0,
			showImprimeAsegurados: false,
			showPolicyInfoModal: false,
			showViewsModal: false,
			selectedRow: null,
			poliza: null,
			enableFilterTabs: false,
			loadingData: false,
			certificadoGenerado: false,
			searchEnabled: true,
			filtersSelected: true,
			filterTabActive: 0,
			filters: [],
			sort: [],
			totalesPrima: 0,
			totalesPremio: 0,
			totalesPremioUsd: 0,
			totalesPrimaUsd: 0,
			searchCriteria: [
				{
					"productores": []
				},
				{
					"fechaDesde": null,
					"fechaHasta": new Date()
				},
				{
					"ramo": '',
					"producto": ''
				},
				{
					"poliza": null,
					"certificado": null,
					"estado": null
				},
				{
					"nombre": null,
					"apellido": null,
					"dni": null
				}
			],
			searchCriteriaText: "",
			productoresData: [],
			showSchedulerModal: false,
			iconFilter: 'fa fa-eye',
			showFilters: false
		};
		this.logoutModalVisible = false;
		this.producerSelector = React.createRef();
		this.showResults = false;
		this.page = 0;
		this.pageSize = 10;
		this.pages = 0;
		this.totalItems = 0;
		this.searchResultsError = "";

		this.searchTableDownloadColumn = {
			Header: "Póliza/Certificado",
			accessor: "actions",
			width: 100,
			style: {
				display: 'flex',
				alignItems: 'center'
			},
			filterable: false,
			sortable: false,
			resizable: true,
			Cell: row => (
				<Actions
					icon="fas fa-file-download"
					onDownload={() => this.downloadItem(row)}
				/>
			)
		};

		this.detailsColumn = {
			Header: "Detalles",
			accessor: "actions",
			width: 75,
			style: {
				display: 'flex',
				alignItems: 'center'
			},
			filterable: false,
			sortable: false,
			resizable: true,
			Cell: row => (
				<Actions
					icon="fas fa-info-circle"
					onDownload={() => this.detailsItem(row)}
				/>
			)
		};

		this.baseTableColumns = this.createBaseTableColumns();
		this.searchTableColumns = this.createSearchTableColumns();

		this.downloadItem = this.downloadItem.bind(this);
		this.onChangeTab = this.onChangeTab.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.clearFiltros = this.clearFiltros.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleResponse = this.handleResponse.bind(this);
		this.handleProducerIdChanged = this.handleProducerIdChanged.bind(this);
		this.handleCheckedItemsChanged = this.handleCheckedItemsChanged.bind(this);
		this.handleProducersChanged = this.handleProducersChanged.bind(this);
		this.handleSaveViewModal = this.handleSaveViewModal.bind(this);
		this.onDismissImprimeAsegurados = this.onDismissImprimeAsegurados.bind(this);
		this.onConfirmImprimeAsegurados = this.onConfirmImprimeAsegurados.bind(this);
	}

	componentDidMount() {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		var userId = userAuth.userId();
		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get()
		};
		this.getInitialData()
		this.getLabels()
		return fetch(PRODUCERURL + "api/producer/GetProducerCodes?userId=" + userId, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				var uc = data;
				for (var u in uc) {
					var item = uc[u];
					for (var p in item.producerCodes) {
						var pc = item.producerCodes[p];
						pc.name = pc.name.split("|")[0];
					}
				}
				this.handleProducersChanged(loadProducerCode(uc));
			});
	}

	getLabels = async () => {
		this.setState({ loadingTotales: true })
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		const requestOptions = {
			method: 'POST',
			headers: DEFAULT_HEADER.get(),
			body: JSON.stringify({
				producerCuit: userAuth.isGestor() ? userAuth.reportTo() : userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
				producerId: this.state.searchCriteria[0].productores.map(x => parseFloat(x.id.replace('X', ''))),
				next: this.pageSize,
				fechaDesde: this.state.searchCriteria[1].fechaDesde,
				fechaHasta: this.state.searchCriteria[1].fechaHasta,
				producto: this.state.searchCriteria[2].producto,
				poliza: this.state.searchCriteria[3].poliza,
				certificado: this.state.searchCriteria[3].certificado,
				nombre: this.state.searchCriteria[4].nombre,
				apellido: this.state.searchCriteria[4].apellido,
				dni: this.state.searchCriteria[4].dni,
				estado: this.state.searchCriteria[3].estado,
			})
		};
		var urlTotales = new URL(`${PRODUCERURL}portfolio/labels`);
		return fetch(urlTotales, requestOptions)
			.then((response) => {
				return QLIBS.authorizeAction(response);
			})
			.then(this.handleLabelsResponse)
			.catch(error => console.log(error));

	}

	handleLabelsResponse = (response) => {
		this.setState({
			productosLabel: [{ value: "", label: '-- SELECCIONAR --' }, ...Object.entries(response.find(x => x.key === 'Productos').values).map(([value, label]) => ({ value, label }))],
			estadosLabel: [{ value: "", label: '-- SELECCIONAR --' }, ...Object.entries(response.find(x => x.key === 'Estados').values).map(([value, label]) => ({ value, label }))],
			loadingTotales: false
		});
	}

	handleResponseOk = (response, fileName) => {
		let self = this;
		response.blob()
			.then(() => {
				self.setState({ certificadoGenerado: true, loadingData: false, item: self.itemInit, showImprimeAsegurados: false });
			});
	}

	handleResponseError = async (response) => {
		let message = '';
		try {
			const text = await response.text();
			let errorMessage = "Ocurrió un error.";
			try {
				const errorData = JSON.parse(text);
				if (errorData.errors && Array.isArray(errorData.errors)) {
					errorMessage = errorData.errors.join(" - ");
				} else {
					errorMessage = text;
				}
			} catch (e) {
				errorMessage = text;
			}
			message = errorMessage;
		} catch (e) {
			message = "No se pudo leer la respuesta.";
		}
		return message;
	}

	getFilter = () => this.state.filters;
	getSort = () => this.state.sort;
	applySort = (event) => {
		if (event.length > 0) {
			this.setState({
				sort: event,
			}, () => this.handleSubmit());
		}
		else {
			this.setState({
				sort: {},
			}, this.handleSubmit);
		}
	}
	changeSize = async (size) => {
		this.pageSize = size;
		this.handleSubmit()
	}
	changePage = async (page) => {
		this.page = page;
		this.handleSubmit()
	}
	getPolizaMatriz(poliza, imprimeAsegurados) {
		this.setState({ loadingData: true });
		const PRODUCERURL = APIS.URLS.DOWNLOAD_CERTIFICADO_MATRIZ;
		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get(),
		};
		fetch(`${PRODUCERURL}?poliza=${poliza}&imprimeAsegurados=${imprimeAsegurados}`, requestOptions)
			.then(response => {
				if (response.ok)
					this.handleResponseOk(response, 'poliza-matriz-' + poliza);
				else
					this.handleResponseError(response);
			})
			.catch(error => {
				this.setState({ error: `Error: ${error.message}`, loadingData: false });
			});
	}

	downloadItem = async event => {
		this.setState({ loadingData: true });
		try {
			const requestOptions = {
				method: 'POST',
				headers: DEFAULT_HEADER.get(),
				body: JSON.stringify({
					email: userAuth.email(),
					branch : event.original.ramo,
					policy: event.original.polizaNumeroOficial,
					product: event.original.codigoProductoVT
				})
			};
			const PRODUCERURL = APIS.URLS.DOWNLOAD_CERTIFICADO_INDIVIDUAL;
			const response = await fetch(`${PRODUCERURL}`, requestOptions);
			if (response.ok) {
				this.searchResultsError = false;
				this.setState({
					showModal: true,
					modalMsg: `En unos minutos recibirá el certificado en el correo electrónico ${userAuth.email()}.`,
					loadingData: false,
					item: this.itemInit
				});
			} else {
				const error = await this.handleResponseError(response);
				this.setState({
					showModal: true,
					modalMsg: `Error: ${error}`,
					loadingData: false,
					item: this.itemInit
				});
			}
		} catch (error) {
			this.setState({ error: `Error: ${error.message}`, loadingData: false });
		}
	};

	onDismissImprimeAsegurados = () => {
		this.getPolizaMatriz(this.state.poliza, false)
	}
	onConfirmImprimeAsegurados = () => {
		this.getPolizaMatriz(this.state.poliza, true)
	}

	detailsItem = event => {
		this.setState({ selectedRow: event.row._original, showPolicyInfoModal: true });
	};

	onChangeTab = index => {
		this.setState({ name: this.state.name, filterTabActive: index, filtersSelected: (index > 0) });
	};

	/// Aplica filtros a nivel frontend
	applyFilter = (event) => {
		if (event.length > 0) {
			this.page = 0
			this.setState({
				filters: event,
			});
		}
		else {
			this.setState({
				filters: [],
			});
		}
	}

	handleKeyDown = event => {
		const { id } = event.target;
		const { keyCode } = event;

		const allowedKeys = [8, 9, 16, 32, 35, 36, 37, 39, 46];
		if (allowedKeys.includes(keyCode)) {
			return;
		}
		switch (id) {
			case "nro_poliza":
			case "nro_certificado":
			case "dni":
				if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105))) {
					event.preventDefault();
				}
				break;

			case "nombre":
			case "apellido":
				if (!((keyCode >= 65 && keyCode <= 90) ||
					keyCode === 109 ||
					keyCode === 189 ||
					keyCode === 219)) {
					event.preventDefault();
				}
				break;

			default:
				break;
		}
	};

	handleComboChange = (selectedOption, event) => {
		let inputName = event.name;
		let inputValue = selectedOption.value;
		//let inputString = selectedOption.label;
		let searchCriteria = this.state.searchCriteria;
		this.page = 0;
		switch (inputName) {
			case "producto":
				searchCriteria[2].producto = inputValue;
				break;
			case "estado":
				searchCriteria[3].estado = inputValue;
				break;

			default:
				break;
		}
		this.setState({
			searchCriteria: searchCriteria,
		}, () => {
			this.refreshFiltros();
		});
	};

	handleChange = event => {
		let searchCriteria = this.state.searchCriteria;
		this.page = 0;
		// Check which field
		switch (event.target.id) {
			case "fecha_emision_desde":
				searchCriteria[1].fechaDesde = event.target.value;
				break;

			case "fecha_emision_hasta":
				searchCriteria[1].fechaHasta = event.target.value;
				break;

			case "nro_poliza":
				searchCriteria[3].poliza = event.target.value;
				break;

			case "nro_certificado":
				searchCriteria[3].certificado = event.target.value;
				break;

			case "nombre":
				searchCriteria[4].nombre = event.target.value;
				break;

			case "apellido":
				searchCriteria[4].apellido = event.target.value;
				break;

			case "dni":
				searchCriteria[4].dni = event.target.value;
				break;

			default:
				break;
		}

		this.setState({
			searchCriteria: searchCriteria,
			searchEnabled: this.totalItems > 0
		}, () => {
			this.refreshFiltros();
		});
	};

	refreshFiltros = () => {
		const filter = {};
		const [prods, fechas, prod, pol, cli] = this.state.searchCriteria;

		// Filtro de productores
		if (prods.productores && prods.productores.length > 0) {
			filter.ProducerId = {
				in: prods.productores.map(p => parseFloat(p.id.replace('X', '')))
			};
			filter.Source = {
				in: prods.productores.map(p => p.core)
			};
		}

		// Filtro de fechas
		if (fechas.fechaDesde) {
			filter.FechaDesde = fechas.fechaDesde;
		}
		if (fechas.fechaHasta) {
			filter.FechaHasta = fechas.fechaHasta;
		}

		// Filtro de producto
		if (prod.producto) {
			filter.ProductCode = Number(prod.producto);
		}

		// Filtro de ramo
		if (prod.ramo) {
			filter.Ramo = prod.ramo;
		}

		// Filtros de póliza
		if (pol.poliza) {
			filter.PolicyNumber = parseInt(pol.poliza);
		}
		if (pol.certificado) {
			filter.CertificateNumber = parseInt(pol.certificado);
		}
		if (pol.estado) {
			filter.StatusWebProducers = pol.estado;
		}

		// Filtros de asociado/cliente
		if (cli.nombre) {
			filter.Nombre = {
				contains: cli.nombre
			};
		}
		if (cli.apellido) {
			filter.Apellido = {
				contains: cli.apellido
			};
		}
		if (cli.dni) {
			filter.RecruiterDni = {
				contains: cli.dni
			};
		}

		this.setState({ filterData: filter });
	};

	clearFiltros = () => {
		const SEARCH_DEFAULT_VALUES = [
			{
				"productores": []
			},
			{
				"fechaDesde": null,
				"fechaHasta": new Date()
			},
			{
				"producto": ''
			},
			{
				"poliza": null,
				"certificado": null,
				"estado": null
			},
			{
				"nombre": null,
				"apellido": null,
				"dni": null
			}
		];
		document.getElementById('fecha_emision_desde').value = '';
		document.getElementById('fecha_emision_hasta').value = moment(new Date()).format("DD/MM/YYYY");
		document.getElementById('nro_poliza').value = '';
		document.getElementById('nro_certificado').value = '';
		document.getElementById('nombre').value = '';
		document.getElementById('apellido').value = '';
		document.getElementById('dni').value = '';
		this.page = 0;
		this.showResults = false;
		this.searchResultsError = false;
		if (this.producerSelector.current && this.producerSelector.current.resetSelection) {
			this.producerSelector.current.resetSelection();
		}
		this.setState({
			certificadoGenerado: false,
			searchCriteria: SEARCH_DEFAULT_VALUES,
			checkedItems: [],
			productorSelected: 0,
			filters: [],
			enableFilterTabs: false
		}, () => {
			this.refreshFiltros();
			this.handleSubmit()
		});
	};

	getInitialData() {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		this.setState({ name: this.state.name, filterTabActive: -1, loadingData: true });
		const requestOptions = {
			method: 'POST',
			headers: DEFAULT_HEADER.get(),
			body: JSON.stringify({
				producerCuit: userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
				next: this.pageSize,
				fechaDesde: this.state.searchCriteria[1].fechaDesde,
				fechaHasta: this.state.searchCriteria[1].fechaHasta,
				estado: this.state.searchCriteria[3].estado,
			})
		};
		var url = new URL(`${PRODUCERURL}portfolio/`);

		return fetch(url, requestOptions)
			.then((response) => {
				return QLIBS.authorizeAction(response);
			})
			.then(this.handleResponse)
			.catch(this.handleResponseError);
	}

	handleSubmit = event => {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		if (event)
			event.preventDefault();
		this.searchResultsError = "";
		this.showResults = false;
		let sort = this.state.sort.length === 0 ? null : this.state.sort[0];
		this.setState({ name: this.state.name, filterTabActive: -1, loadingData: true });
		const requestOptions = {
			method: 'POST',
			headers: DEFAULT_HEADER.get(),
			body: JSON.stringify({
				next: this.pageSize,
				sort: sort,
				offset: this.page * this.pageSize,
				producerCuit: userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
				producerId: this.state.searchCriteria[0].productores.map(x => parseFloat(x.id.replace('X', ''))),
				fechaDesde: this.state.searchCriteria[1].fechaDesde,
				fechaHasta: this.state.searchCriteria[1].fechaHasta,
				producto: this.state.searchCriteria[2].producto,
				poliza: this.state.searchCriteria[3].poliza,
				certificado: this.state.searchCriteria[3].certificado,
				estado: this.state.searchCriteria[3].estado,
				nombre: this.state.searchCriteria[4].nombre,
				apellido: this.state.searchCriteria[4].apellido,
				dni: this.state.searchCriteria[4].dni,
				gridFilters: this.state.filters
			})
		};
		var url = new URL(`${PRODUCERURL}portfolio/`);

		return fetch(url, requestOptions)
			.then((response) => {
				return QLIBS.authorizeAction(response);
			})
			.then(this.handleResponse)
			.catch(this.handleResponse);

	};

	handleCheckedItemsChanged(checkedItems) {
		let searchCriteria = this.state.searchCriteria;
		searchCriteria[0].productores = checkedItems;
		this.setState({
			checkedItems: checkedItems,
			searchCriteria: searchCriteria
		}, () => {
			this.refreshFiltros();
		});
	}

	handleProducerIdChanged(producerId) {
		this.setState({ productorSelected: producerId });
	}

	handleProducersChanged(newProducers) {
		this.setState({ productoresData: newProducers.filter(x => x.core === 'EOS') });
	};

	handleResponse(response) {
		const { COMMON_SEARCH_FORM } = GLOBAL;
		let tableData = [];
		this.setState({ loadingTotales: true })
		try {
			if (Array.isArray(response.data)) {
				this.searchResultsError = "";
				this.showResults = true;
				this.totalItems = response.total;
				this.pages = Math.ceil(response.total / this.pageSize);
				this.setTotales(response);
				tableData = response.data.map(item => ({
					...item,
					prima: `$ ${truncate(item.prima, 2)}`,
					premio: `$ ${truncate(item.premio, 2)}`,
				}));

			} else {
				this.searchResultsError = COMMON_SEARCH_FORM.SERVER_ERROR;
				this.showResults = false;
				return;
			}


			this.searchTableColumns = this.createSearchTableColumns();

			this.searchTableData = {
				makeData: () => {
					return tableData
				}
			};
		} catch (error) {
			console.log(error)
		}
		finally {
			this.setState({ name: this.state.name, loadingData: false, loadingTotales: false });
		}

	}

	setTotales(response) {
		const items =
			response?.sumarizeItems ??
			response?.summarizeItems ??
			[];
		const get = (k) => {
			const found = items.find(x => x?.key === k);
			const n = Number(found?.total);
			return Number.isFinite(n) ? n : 0;
		};
		const fallback = response?.totales ?? {};
		this.totalesPremio = items.length ? get('Premium') : (Number(fallback.premio) || 0);
		this.totalesPrima = items.length ? get('Reward') : (Number(fallback.prima) || 0);
		this.totalesPremioUsd = items.length ? get('PremiumUSD') : (Number(fallback.premioUsd) || 0);
		this.totalesPrimaUsd = items.length ? get('RewardUSD') : (Number(fallback.primaUsd) || 0);
		this.totalesArs = items.length ? get('CountARS') : (Number(fallback.countArs) || 0);
		this.totalesUsd = items.length ? get('CountUSD') : (Number(fallback.countUsd) || 0);

	}


	handleExportSubmit(event) {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

		event.preventDefault();
		this.setState({ loadingData: true });

		const requestOptions = {
			method: 'POST',
			headers: DEFAULT_HEADER.get(),
			body: JSON.stringify({
				producerId: this.state.searchCriteria[0].productores.map(x => parseFloat(x.id.replace('X', ''))),
				producerCuit: userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
				fechaDesde: this.state.searchCriteria[1].fechaDesde,
				fechaHasta: this.state.searchCriteria[1].fechaHasta,
				producto: this.state.searchCriteria[2].producto,
				poliza: this.state.searchCriteria[3].poliza,
				certificado: this.state.searchCriteria[3].certificado,
				estado: this.state.searchCriteria[3].estado,
				nombre: this.state.searchCriteria[4].nombre,
				apellido: this.state.searchCriteria[4].apellido,
				dni: this.state.searchCriteria[4].dni,
				filters: this.state.searchCriteriaText.replace(/['"]+/g, "\\'"),
				columns: JSON.stringify(this.createExcelReportColumns())
			})
		};

		fetch(`${PRODUCERURL}portfolio/export`, requestOptions)
			.then(function (resp) {
				if (resp.ok)
					return resp.blob();
			})
			.then(function (blob) {
				if (blob) {
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = "Cartera.xlsx";
					link.click();
				}
			})
			.then(() => {
				this.setState({ loadingData: false });
			})
	};

	handleSaveViewModal(newListColumns) {
		const tempTableColumns = this.createBaseTableColumns();

		this.baseTableColumns = newListColumns.map(c => {
			let col = tempTableColumns.find(f => f.name === c.name);
			col.show = c.show;
			return col;
		});

		this.searchTableColumns = this.createSearchTableColumns();
	}

	onKeyDown = (event) => {
		if (event.key === 'Enter' && this.state.searchEnabled) {
			event.preventDefault();
			event.stopPropagation();
			document.getElementById("btnSubmit").click();
		}
	}

	createSearchTableColumns() {
		const newTableColumns = [this.searchTableDownloadColumn, ...this.baseTableColumns.filter(f => f.show)];
		return newTableColumns;
	}

	createExcelReportColumns() {
		const excelReportColumns = this.baseTableColumns.filter(f => f.show).map(c => {
			return {
				Title: c.title,
				Field: c.field,
				Summarize: c.summarize,
				Format: c.format
			}
		});
		return excelReportColumns;
	}

	createBaseTableColumns() {
		let newTableColumns = [];
		let columns = {
			"polizaNumeroOficial": { title: "Nro. Póliza", field: "polizaNumeroOficial", show: true,tooltip:'Número interno de Life Seguros para identificar tu póliza.' },
			"polizaNumero": { title: "Nro. Referencia", field: "polizaNumero", show: true,tooltip:'Es tu identificador principal. Usalo en todas las gestiones con nosotros.' },
			"productoDescripcion": { title: "Producto", field: "productoDescripcion", show: true },
			"planDescripcion": { title: "Plan", field: "planDescripcion", show: true },
			"prima": { title: "Prima", field: "prima", show: true },
			"premio": { title: "Premio", field: "premio", show: true },
			"tipoFacturacion": { title: "Tipo Facturación", field: "tipoFacturacion", show: true },
			"moneda": { title: "Moneda", field: "moneda", show: true },
			"medioPago": { title: "Medio de Pago", field: "medioPago", show: true },
			"estado": { title: "Estado", field: "estado", show: true },
			"contratanteTipoDocumento": { title: "Tipo Documento", field: "contratanteTipoDocumento", show: true },
			"contratanteDocumento": { title: "Documento", field: "contratanteDocumento", show: true },
			"productoCodigo": { title: "Cód. Producto", field: "productoCodigo", show: true },

		};
		let cols = QLIBS.getTableColumns(columns);
		cols.forEach((c) => { newTableColumns.push(c) });

		return newTableColumns;
	}

	getAppliedFiltersBadges = () => {
		const [prods, fechas, prod, pol, cli] = this.state.searchCriteria;
		const badges = [];

		if ((prods.productores || []).length)
			badges.push(...prods.productores.map(p => `Prod: ${p.name ?? p.id}`));
		if (fechas.fechaDesde) badges.push(`Desde ${moment(fechas.fechaDesde).format('DD/MM/YYYY')}`);
		if (fechas.fechaHasta) badges.push(`Hasta ${moment(fechas.fechaHasta).format('DD/MM/YYYY')}`);
		if (prod.producto) {
			const label = (this.state.productosLabel || []).find(o => o.value === String(prod.producto))?.label ?? prod.producto;
			badges.push(`Producto: ${label}`);
		}
		if (prod.ramo) badges.push(`Ramo: ${prod.ramo}`);
		if (pol.poliza) badges.push(`Póliza: ${pol.poliza}`);
		if (pol.certificado) badges.push(`Cert: ${pol.certificado}`);
		if (pol.estado) {
			const estLabel = (this.state.estadosLabel || []).find(o => o.value === String(pol.estado))?.label ?? pol.estado;
			badges.push(`Estado: ${estLabel}`);
		}
		if (cli.nombre) badges.push(`Nombre: ${cli.nombre}`);
		if (cli.apellido) badges.push(`Apellido: ${cli.apellido}`);
		if (cli.dni) badges.push(`DNI: ${cli.dni}`);

		return badges;
	};


	render(...props) {
		const { TABLE_VIEW } = GLOBAL;
		const { COMMON_SEARCH_FORM } = GLOBAL;
		return (
			<>
				{this.state.showImprimeAsegurados && <ConfirmationModal
					message={"¿Desea imprimir el detalle de asegurados?"}
					status="success"
					title={"Descarga de Certificado"}
					onDismiss={() => this.onDismissImprimeAsegurados()}
					onConfirm={() => this.onConfirmImprimeAsegurados()}
					onCancel={() => this.setState({ showImprimeAsegurados: false })}
				/>}
				{this.state.showViewsModal && <ViewsModal
					listColumns={this.baseTableColumns}
					onDismiss={() => { this.setState({ showViewsModal: false }) }}
					onSave={(listColumns) => { this.handleSaveViewModal(listColumns) }}
				/>}
				<Loading visible={this.state.loadingData}></Loading>
				{this.state.showModal && <InformationModal title='Descarga de póliza/certificado' icon='fa fa-exclamation-triangle' message={this.state.modalMsg} onConfirm={() => this.setState({ showModal: false })}></InformationModal>}
				{this.state.showPolicyInfoModal && <PolicyInfoModal policy={this.state.selectedRow}
					onDismiss={() => { this.setState({ showPolicyInfoModal: false }) }} />}
				{this.state.showSchedulerModal && (<SchedulerModal reporte="Portfolio" api={`portfolio/export`} productores={this.state.searchCriteria[0].productores.map((item) => { return item.id.replace('X', '') })} cores={this.state.searchCriteria[0].productores.map((item) => { return item.core })} dismiss={() => { this.setState({ showSchedulerModal: false }) }} />)}
				<section className="col-12">
					<div className="row">
						<div className="col-12">
							<Breadcrumb currentPage="/cartera" />
						</div>
						<div className="col-12 mb-2">
							<LabelSection section="cartera" type="subtitulo" className="form-title" />
						</div>
						<div className="form-container container table-view col-md-12 mt-2">
							<form id="cartera_search_form_1" onSubmit={this.handleSubmit} onKeyDown={this.onKeyDown} className="register__Form" noValidate>
								<div className="row">
									<div className="col-12">
										<TabsPanel options={this.filterTabs} tabActive={this.state.filterTabActive} onChange={this.onChangeTab}>
											<div id="tab2" className="container option-2">
												<div className="col-12 pt-3">
													<div className="container">
														<div className="row">
															<div className="col-md-6">
																<label>{COMMON_SEARCH_FORM.FECHA_EMISION.DESDE}</label>
																<DatePicker
																	id="fecha_emision_desde"
																	defaultValue={(this.state.searchCriteria[1].fechaDesde) ? this.state.searchCriteria[1].fechaDesde.toString() : ""}
																	maxLength="10"
																	noDefaultValue="true"
																	onKeyDown={this.handleKeyDown}
																	onChange={this.handleChange}
																/>
															</div>
															<div className="col-md-6">
																<label>{COMMON_SEARCH_FORM.FECHA_EMISION.HASTA}</label>
																<DatePicker
																	id="fecha_emision_hasta"
																	defaultValue={(this.state.searchCriteria[1].fechaHasta) ? this.state.searchCriteria[1].fechaHasta.toString() : ""}
																	maxLength="10"
																	noDefaultValue="true"
																	onKeyDown={this.handleKeyDown}
																	onChange={this.handleChange}
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div id="tab3" className="container option-3">
												<div className="col-12 pt-3">
													<div className="container">
														<div className="row">
															<div className="col-md-6">
																{this.state.productosLabel &&
																	(<Combobox
																		id="producto"
																		label={COMMON_SEARCH_FORM.PRODUCTO}
																		options={this.state.productosLabel}
																		onChange={(v, e) => { this.handleComboChange(v, e); }}
																		defaultValue={this.state.searchCriteria[2].producto}
																	/>)
																}

															</div>
														</div>
													</div>
												</div>
											</div>
											<div id="tab4" className="container option-4">
												<div className="col-12 pt-3">
													<div className="container">
														<div className="row">
															<div className="col-md-4">
																<Input
																	id="nro_poliza"
																	type="text"
																	text={COMMON_SEARCH_FORM.NRO_POLIZA}
																	defaultValue={this.state.searchCriteria[3].poliza}
																	classes="mb-0"
																	maxLength="50"
																	onChange={this.handleChange}
																/>
															</div>
															<div className="col-md-4">
																<Input
																	id="nro_certificado"
																	type="text"
																	text={COMMON_SEARCH_FORM.NRO_CERTIFICADO}
																	defaultValue={this.state.searchCriteria[3].certificado}
																	classes="mb-0"
																	maxLength="50"
																	onKeyDown={this.handleKeyDown}
																	onChange={this.handleChange}
																/>
															</div>
															<div className="col-md-4">
																{
																	this.state.estadosLabel && (
																		<Combobox
																			id="estado"
																			label={COMMON_SEARCH_FORM.ESTADO}
																			options={this.state.estadosLabel}
																			onChange={(v, e) => { this.handleComboChange(v, e); }}
																			defaultValue={this.state.searchCriteria[3].estado}
																		/>
																	)
																}
															</div>
														</div>
													</div>
												</div>
											</div>
										</TabsPanel>
									</div>
								</div>

								{(this.state.productorSelected <= 0) && (!this.state.filtersSelected) && (!this.state.searchEnabled) && (
									<div className="row">
										<div className="col-12 mt-3">
											<div className="alert-modal text-center text-lg-left text-light" role="alert">
												<div className="d-md-inline">
													<LabelSection section="cartera" type="aviso" className="alert-modal-info alert-modal-info-label" />
												</div>
											</div>
										</div>
									</div>
								)}
								{(this.state.searchEnabled) && (
									<div className="row mt-3">
										<div className="col-12">
											<div className="search-buttons">
												<Button type="submit" id="btnSubmit" classes="to-bottom button-small search-button"><span className="fa fa-search"> </span> {COMMON_SEARCH_FORM.SEARCH_BUTTON}</Button>
											</div>
											<div className="search-buttons">
												<Button type="button" classes="to-bottom button-small search-button" onClick={this.clearFiltros}><span className="fa fa-filter"> </span> {COMMON_SEARCH_FORM.CLEAR_FILTERS}</Button>
											</div>
											{(this.state.searchEnabled && this.showResults && this.totalItems > 0) && (
												<div className="search-buttons">
													<Button type="submit" onClick={event => this.handleExportSubmit(event)} size="small">
														<i className="fas fa-file-download mx-2" /> {TABLE_VIEW.EXPORT_TEXT}</Button>
												</div>
											)}
											{APPCONFIG.ENABLESCHEDULER === "true" && (
												<div className="search-buttons">
													<Button type="button" classes="to-bottom button-small search-button" onClick={() => { this.setState({ showSchedulerModal: true }) }}><span className="fa fa-clock-o"> </span> {COMMON_SEARCH_FORM.SCHEDULER_BUTTON}</Button>
												</div>
											)}
											<div className="search-buttons">
												<Button type="button" classes="to-bottom button-small search-button" onClick={() => { this.setState({ showViewsModal: true }) }}><span className="fa fa-table"> </span> {COMMON_SEARCH_FORM.VIEW_BUTTON}</Button>
											</div>
											<div className="search-buttons search-filters">
												<table style={{ width: '100%' }}>
													<tbody>
														<tr>
															<td><Button type="button" id="btnView" classes="to-bottom button-small search-button" onClick={() => { this.setState({ iconFilter: this.state.iconFilter === 'fa fa-eye' ? 'fa fa-eye-slash' : 'fa fa-eye', showFilters: !this.state.showFilters }) }}><span className={this.state.iconFilter}> </span> {COMMON_SEARCH_FORM.VIEW_FILTERS}</Button></td>
															{this.state.searchEnabled && this.showResults && (<td>{`Se encontraron ${this.totalItems} registros`}</td>)}
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								)}
								{this.state.showFilters && (
									<div className="row d-flex">
										<div className="h6 col-12 d-flex flex-wrap gap-3">
											{this.getAppliedFiltersBadges().map((b, i) => (
												<span key={i} className="badge m-1 badge-pill badge-secondary">{b}</span>
											))}
										</div>
									</div>
								)}
								{this.searchResultsError && (
									<div id="form-error-message" className="row my-2">
										<div className="col-12">
											<Alert
												icon="times"
												message=""
												title={this.searchResultsError}
												errorInfo={this.searchResultsError}
												level={ErrorLevel.Error}
											/>
										</div>
									</div>
								)}
								{
									(this.state.certificadoGenerado) &&
									<div id="form-error-message" className="row my-2">
										<div className="col-12">
											<Alert
												title={"Certificado generado con éxito"}
												level={ErrorLevel.Success}
												noDetail={true}
											/>
										</div>
									</div>
								}
								{(this.showResults) && (
									<div className="row my-3">

										<div className="col-12 px-3">
											{this.state.loadingTotales ? <div className='cards'>
												<div className="spinner"></div>
											</div> :
												<div className='row mb-2'>
													<div className='col-6'>
														<div className="totales-block">
															<div className="totales-title mb-2">
																Total de pólizas vigentes en pesos: {this.totalesArs ?? '0'}
																<span className="totales-count">{this.totalPoliciesArsCount}</span>
															</div>
															<div className="totales-row">
																<div>
																	<b>Premio:</b> {fmtMoney(this.totalesPremio, "ARS")}
																</div>
																<div>
																	<b>Prima:</b> {fmtMoney(this.totalesPrima, "ARS")}
																</div>
															</div>
														</div>
													</div>
													<div className='col-6'>
														<div className="totales-block">
															<div className="totales-title mb-2">
																Total de pólizas vigentes en dólares: {this.totalesUsd ?? '0'}
																<span className="totales-count">{this.totalPoliciesUsdCount}</span>
															</div>
															<div className="totales-row">
																<div>
																	<b>Premio:</b> {fmtMoney(this.totalesPremioUsd, "USD")}
																</div>
																<div>
																	<b>Prima:</b> {fmtMoney(this.totalesPrimaUsd, "USD")}
																</div>
															</div>
														</div>
													</div>
												</div>
											}


											<TableComponent
												columns={this.searchTableColumns}
												sorted={this.getSort()}
												onSortedChange={this.applySort}
												filter={this.getFilter()}
												data={this.searchTableData.makeData()}
												manual={true}
												onFilterChange={this.applyFilter}
												page={this.page}
												pageSize={this.pageSize}
												onPageSizeChange={this.changeSize}
												pages={this.pages}
												changePage={this.changePage}
												expandable={true}
												subComponent={props => (<PolicyRowDetail width={(window.innerWidth - 120)} {...props} />)}
												{...props}
											/>
										</div>
									</div>
								)}
							</form>
						</div>
					</div>
				</section>
			</>
		);
	}
}

export default Cartera;
